<template>
    <div class="rightBlock FNButtonC">
      <link v-bind:href="dynamicCssPath" rel="stylesheet" type="text/css">
      <el-container>
          <el-main>

        <div class="tab" style="display: block;">
        <child-fnProductc ref="childFNProductc"></child-fnProductc>

        <el-dialog :title="$t('buttonTab.hotkey')" 
            width="50%" 
            :close-on-click-modal="false" 
            :close-on-press-escape="false"
            :visible.sync="dialogToolsVisible">

          <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
          <child-toolsc :key="componentKey" ref="childToolsc"></child-toolsc>

          <div slot="footer" class="dialog-footer">
            <el-button  @click="dialogToolsVisible = false">{{$t("buttonTab.cancelInfo")}}</el-button>
            <el-button type="primary" @click="saveHotKey">{{$t("buttonTab.saveInfo")}}</el-button>
          </div>
        </el-dialog>

        <el-dialog :title="$t('buttonTab.macro')" 
          width="50%" 
          :close-on-click-modal="false" 
          :close-on-press-escape="false"
          :visible.sync="dialogMacroVisible">
        <el-alert v-show="msgShow" :title="msg" type="warning" closable="false" center show-icon></el-alert>
        <child-macroC ref="childMacroc"></child-macroC>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogMacroVisible = false">{{$t("buttonTab.cancelInfo")}}</el-button>
          <el-button type="primary" @click="saveMacro">{{$t("buttonTab.saveInfo")}}</el-button>
        </div>
        </el-dialog>

        <!-- <div class="fnlist">
          <ul style="width: 100%">
            <li v-for="item in fnData" :name="item.type">{{item.name}}</li>
          </ul>
        </div> -->

        <div class="channel">
          
            <el-dropdown @command="handleTools">
                <el-button type="primary">
                {{$t("buttonTab.tools")}} <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu class="funcOP" slot="dropdown">
                <el-dropdown-item class="tools" command="tools">{{$t("buttonTab.hotkey")}}</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>

            <div tip>{{$t("advancedTab.tip")}}</div>
            <el-tabs ref="tabs" v-model="tabName" @tab-click="handleTabClick">
                <el-tab-pane :label="$t('buttonTab.buttonTab')" ref="buttonTab" name="button">
                    <buttonPaneC></buttonPaneC>
                </el-tab-pane>

                <el-tab-pane :label="$t('buttonTab.systemTab')" ref="systemTab" name="system">
                <ul class="functions scroll" data-type="HOTKEY">
                    <li :style="getIconPath('system/desktop.png')" data-index="4" data-task="Win+D" data-type="HOTKEY" :data-name="$t('defineData.hotkey.WD')"><span>{{$t("defineData.hotkey.WD")}}</span></li>
                    <li :style="getIconPath('system/mycomputer.png')" data-index="6" data-task="Win+E" data-type="HOTKEY" :data-name="$t('defineData.hotkey.WE')"><span>{{$t("defineData.hotkey.WE")}}</span></li>
                    <li :style="getIconPath('system/copy.png')" data-index="2" data-task="Ctrl+C" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CC')"><span>{{$t("defineData.hotkey.CC")}}</span></li>
                    <li :style="getIconPath('system/shear.png')" data-index="7" data-task="Ctrl+X" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CX')"><span>{{$t("defineData.hotkey.CX")}}</span></li>
                    <li :style="getIconPath('system/paste.png')" data-index="8" data-task="Ctrl+V" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CV')"><span>{{$t("defineData.hotkey.CV")}}</span></li>
                    <li :style="getIconPath('system/revoke.png')" data-index="9" data-task="Ctrl+Z" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CZ')"><span>{{$t("defineData.hotkey.CZ")}}</span></li>
                    <li :style="getIconPath('system/Selectall.png')" data-index="10" data-task="Ctrl+A" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CA')"><span>{{$t("defineData.hotkey.CA")}}</span></li>
                    <li :style="getIconPath('system/find.png')" data-index="11" data-task="Ctrl+F" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CF')"><span>{{$t("defineData.hotkey.CF")}}</span></li>
                    <li :style="getIconPath('system/newfile.png')" data-index="12" data-task="Ctrl+N" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CN')"><span>{{$t("defineData.hotkey.CN")}}</span></li>
                    <li :style="getIconPath('system/Print.png')" data-index="13" data-task="Ctrl+P" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CP')"><span>{{$t("defineData.hotkey.CP")}}</span></li>
                    <li :style="getIconPath('system/save.png')" data-index="14" data-task="Ctrl+S" data-type="HOTKEY" :data-name="$t('defineData.hotkey.CS')"><span>{{$t("defineData.hotkey.CS")}}</span></li>
                    <li :style="getIconPath('system/run.png')" data-index="15" data-task="Win+R" data-type="HOTKEY" :data-name="$t('defineData.hotkey.WR')"><span>{{$t("defineData.hotkey.WR")}}</span></li>
                    <li :style="getIconPath('system/Lockcomputer.png')" data-index="16" data-task="Win+L" data-type="HOTKEY" :data-name="$t('defineData.hotkey.WL')"><span>{{$t("defineData.hotkey.WL")}}</span></li>
                    <li :style="getIconPath('system/windowClose.png')" data-index="0" data-task="Alt+F4" data-type="HOTKEY" :data-name="$t('defineData.hotkey.AF')"><span>{{$t("defineData.hotkey.AF")}}</span></li>
                    <li :style="getIconPath('system/togglewindow.png')" data-index="3" data-task="Alt+Tab" data-type="HOTKEY" :data-name="$t('defineData.hotkey.AT')"><span>{{$t("defineData.hotkey.AT")}}</span></li>
                </ul>
                </el-tab-pane>
                <el-tab-pane :label="$t('buttonTab.mediaTab')" ref="mediaTab" name="media">
                <ul class="functions scroll" data-type="Media" data-package="{{info.multimedia}}">
                    <li :style="getIconPath('media/player.png')" data-type="Media"   data-task="0x83,0x11" :data-name="$t('defineData.media.MMT')"><span>{{$t("defineData.media.MMT")}}</span></li>
                    <li :style="getIconPath('media/Playpause.png')" data-type="Media"  data-task="0xCD,0x10" :data-name="$t('defineData.media.MBF')"><span>{{$t("defineData.media.MBF")}}</span></li>
                    <li :style="getIconPath('media/stop.png')" data-type="Media"   data-task="0xB7,0x10" :data-name="$t('defineData.media.MTZ')"><span>{{$t("defineData.media.MTZ")}}</span></li>
                    <li :style="getIconPath('media/previous.png')" data-type="Media"   data-task="0xB6,0x10" :data-name="$t('defineData.media.MSY')"><span>{{$t("defineData.media.MSY")}}</span></li>
                    <li :style="getIconPath('media/next.png')" data-type="Media"   data-task="0xB5,0x10" :data-name="$t('defineData.media.MXY')"><span>{{$t("defineData.media.MXY")}}</span></li>
                    <li :style="getIconPath('media/volume+.png')" data-type="Media"   data-task="0xE9,0x10" :data-name="$t('defineData.media.MTG')"><span>{{$t("defineData.media.MTG")}}</span></li>
                    <li :style="getIconPath('media/volume-.png')" data-type="Media"   data-task="0xEA,0x10" :data-name="$t('defineData.media.MJD')"><span>{{$t("defineData.media.MJD")}}</span></li>
                    <li :style="getIconPath('media/Mute.png')" data-type="Media"   data-task="0xE2,0x10" :data-name="$t('defineData.media.MJY')"><span>{{$t("defineData.media.MJY")}}</span></li>    

                    <li :style="getIconPath('media/BrightnessU.png')" data-type="Media"   data-task="0x6F,0x10" :data-name="$t('defineData.media.MLU')"><span>{{$t("defineData.media.MLU")}}</span></li>
                    <li :style="getIconPath('media/BrightnessD.png')" data-type="Media"   data-task="0x70,0x10" :data-name="$t('defineData.media.MLD')"><span>{{$t("defineData.media.MLD")}}</span></li>
                    <li :style="getIconPath('media/email.png')" data-type="Media"   data-task="0x8a,0x11" :data-name="$t('defineData.media.MEM')"><span>{{$t("defineData.media.MEM")}}</span></li>
                    <li :style="getIconPath('media/calc.png')" data-type="Media"  data-task="0x92,0x11" :data-name="$t('defineData.media.MJS')"><span>{{$t("defineData.media.MJS")}}</span></li>
                    <li :style="getIconPath('media/web_search.png')" data-type="Media"  data-task="0x21,0x12" :data-name="$t('defineData.media.MSS')"><span>{{$t("defineData.media.MSS")}}</span></li>
                    <li :style="getIconPath('media/web_home.png')" data-type="Media"  data-task="0x23,0x12" :data-name="$t('defineData.media.MZY')"><span>{{$t("defineData.media.MZY")}}</span></li>
                    <li :style="getIconPath('media/web_back.png')" data-type="Media"  data-task="0x24,0x12" :data-name="$t('defineData.media.MHT')"><span>{{$t("defineData.media.MHT")}}</span></li>
                    <li :style="getIconPath('media/web_refresh.png')" data-type="Media"  data-task="0x27,0x12" :data-name="$t('defineData.media.MSX')"><span>{{$t("defineData.media.MSX")}}</span></li>
                    <li :style="getIconPath('media/web_bookmarks.png')" data-type="Media"  data-task="0x2A,0x12" :data-name="$t('defineData.media.MSQ')"><span>{{$t("defineData.media.MSQ")}}</span></li>
                </ul>
                </el-tab-pane>
                <el-tab-pane :label="$t('buttonTab.mouseTab')" ref="mouseTab" name="mouse">
                <ul class="functions scroll" data-type="Media" data-package="{{info.multimedia}}">              
                    <li :style="getIconPath('mouse/leftkey.png')"  data-type="mouse"  :data-name="$t('defineData.mouse.MMT')" data-task="0x01,0x73"><span>{{$t("defineData.mouse.MMT")}}</span></li>
                    <li :style="getIconPath('mouse/rightkey.png')" data-type="mouse"   :data-name="$t('defineData.mouse.MBF')" data-task="0x02,0x73"><span>{{$t("defineData.mouse.MBF")}}</span></li>
                    <li :style="getIconPath('mouse/middlekey.png')" data-type="mouse"   :data-name="$t('defineData.mouse.MTZ')" data-task="0x03,0x73"><span>{{$t("defineData.mouse.MTZ")}}</span></li>
                    <li :style="getIconPath('mouse/forward.png')"  data-type="mouse"  :data-name="$t('defineData.mouse.MSY')" data-task="0x08,0x73"><span>{{$t("defineData.mouse.MSY")}}</span></li>
                    <li :style="getIconPath('mouse/back.png')" data-type="mouse"   :data-name="$t('defineData.mouse.MXY')" data-task="0x09,0x73"><span>{{$t("defineData.mouse.MXY")}}</span></li>
                    <li :style="getIconPath('mouse/xjj.png')" data-type="mouse"   :data-name="$t('defineData.mouse.MTG')" data-task="0x05,0x73"><span>{{$t("defineData.mouse.MTG")}}</span></li>
                    <li :style="getIconPath('mouse/xj.png')" data-type="mouse"   :data-name="$t('defineData.mouse.MJD')" data-task="0x04,0x73"><span>{{$t("defineData.mouse.MJD")}}</span></li>
                    <li :style="getIconPath('mouse/yjj.png')"  data-type="mouse"  :data-name="$t('defineData.mouse.MJY')" data-task="0x07,0x73"><span>{{$t("defineData.mouse.MJY")}}</span></li>
                    <li :style="getIconPath('mouse/yj.png')" data-type="mouse"   :data-name="$t('defineData.mouse.MLU')" data-task="0x06,0x73"><span>{{$t("defineData.mouse.MLU")}}</span></li>

                </ul>
                </el-tab-pane>
                                <el-tab-pane :label="$t('buttonTab.FirmwareTab')" ref="firmwareTab" name="firmware">
                  <ul class="functions scroll" data-type="Media" data-package="{{info.multimedia}}">              
                      <!-- <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.PZ1')" data-task="0x08,0xF1"><span>{{$t("defineData.media.PZ1")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')" data-type="Media"   :data-name="$t('defineData.media.PZ2')" data-task="0x09,0xF1"><span>{{$t("defineData.media.PZ2")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')" data-type="Media"   :data-name="$t('defineData.media.PZ3')" data-task="0x0A,0xF1"><span>{{$t("defineData.media.PZ3")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.PZ4')" data-task="0x0C,0xF1"><span>{{$t("defineData.media.PZ4")}}</span></li> -->

                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBSwitch')" data-task="0x17,0xf3"><span>{{$t("defineData.media.RGBSwitch")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBU')" data-task="0x10,0xf3"><span>{{$t("defineData.media.RGBU")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBD')" data-task="0x2f,0xf3"><span>{{$t("defineData.media.RGBD")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBMode')" data-task="0x11,0xf3"><span>{{$t("defineData.media.RGBMode")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBSpedU')" data-task="0x14,0xf3"><span>{{$t("defineData.media.RGBSpedU")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBSpedD')" data-task="0x15,0xf3"><span>{{$t("defineData.media.RGBSpedD")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLightU')" data-task="0x12,0xf3"><span>{{$t("defineData.media.RGBLightU")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLightD')" data-task="0x13,0xf3"><span>{{$t("defineData.media.RGBLightD")}}</span></li>

                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOSwitch')" data-task="0x26,0xf3"><span>{{$t("defineData.media.RGBLOGOSwitch")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOU')" data-task="0x25,0xf3"><span>{{$t("defineData.media.RGBLOGOU")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOD')" data-task="0x2c,0xf3"><span>{{$t("defineData.media.RGBLOGOD")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOMode')" data-task="0x27,0xf3"><span>{{$t("defineData.media.RGBLOGOMode")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOSpedU')" data-task="0x28,0xf3"><span>{{$t("defineData.media.RGBLOGOSpedU")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOpedD')" data-task="0x29,0xf3"><span>{{$t("defineData.media.RGBLOGOpedD")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOightU')" data-task="0x2a,0xf3"><span>{{$t("defineData.media.RGBLOGOightU")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.RGBLOGOLightD')" data-task="0x2b,0xf3"><span>{{$t("defineData.media.RGBLOGOLightD")}}</span></li>
                      
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.DeviceMac')" data-task="0x02,0xf1"><span>{{$t("defineData.media.DeviceMac")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.DeviceWin')" data-task="0x01,0xf1"><span>{{$t("defineData.media.DeviceWin")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.DeviceCalibration')" data-task="0x03,0xf1"><span>{{$t("defineData.media.DeviceCalibration")}}</span></li>
                      <li :style="getIconPath('media/profiles.png')"  data-type="Media"  :data-name="$t('defineData.media.DeviceReset')" data-task="0x00,0xf1"><span>{{$t("defineData.media.DeviceReset")}}</span></li>
                  </ul>
                </el-tab-pane>
                <el-tab-pane :label="$t('buttonTab.hotkey')" ref="hotkeyTab" name="HOTKEY">

                    <el-empty v-if="myfuns.length == 0" :description="$t('buttonTab.emptyInfo')"></el-empty>

                    <ul class="functions scroll" v-if="myfuns.length > 0">
                    <li v-for="item in myfuns"
                        :style="getIconTypePath(item.type,item.icon)"
                        :data-index="index"
                        :data-md5="item.md5"
                        :data-type="item.type"   
                        :data-name="item.name" 
                        :data-task="item.content"
                    ><span>{{showCommandName(item)}}</span><i></i></li>
                    </ul>
                </el-tab-pane>

  
                      </el-tabs>						
                  </div>
              </div>
          </el-main>
      </el-container>
  </div>
</template>
<script>
import $ from 'jquery'
import Base64 from 'base-64';
import SparkMD5 from 'spark-md5';

import fnData from '../../../../theme/fn.map.json';
import KeyboardMapConf from '../../../../theme/keyboard.map.json';
import cmd10 from '../../../../theme/cmd1.0.config.json';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../../../asserts/js/hid_device.js';
// 命令数据功能操作对象
import { CommandHandle } from '../../../../utils/command_handle.js';
import { ToolsHandle } from '../../../../utils/tools.js';

import productButtonC from './buttonTabPane/fnProduct.vue'
import buttonPaneC from './buttonTabPane/buttonPaneC.vue'

import toolsC from '../../../../components/box/tools.vue'
import macroC from '../../../../components/box/macro.vue'
import dksC from '../../../../components/box/dks.vue'
import mtC from '../../../../components/box/mt.vue'
import tglC from '../../../../components/box/tgl.vue'
import mptC from '../../../../components/box/mpt.vue'
import endC from '../../../../components/box/end.vue'

export default {
name: 'fnButtonTabC',
components: 
{
    'child-fnProductc':productButtonC,
      buttonPaneC,
    'child-toolsc':toolsC,
    'child-macroC':macroC,
    'child-dksC':dksC,
    'child-mtC':mtC,
    'child-tglC':tglC,
    'child-mptC':mptC,
    'child-end':endC,
},
data() 
{
  return {
    HIDDeviceObj:null,
    tabName: 'button',
    fnData: [],
    componentKey:0,
    msg:"",
    msgShow:false,
    myfuns:[],
    dialogToolsVisible:false,
    dialogMacroVisible:false,
    dialogDKSVisible:false,
    dialogMTVisible:false,
    dialogTGLVisible:false,
    dialogMPTVisible:false,
    dialogENDVisible:false,

    dragging: false,
    mouseX: 0,
    mouseY: 0,
    initialX: 0,
    initialY: 0,
    offsetX: 0,
    offsetY: 0
  }
},
mounted() 
{
    this.$refs.tabs.$el.querySelector(".el-tabs__active-bar").style.width = "60px";
    //刷新自定义命令数据
    this.refreshData("HOTKEY");
    setTimeout(()=>{this.JQSet();},500);
    
},
methods: 
{
  //刷新自定义命令数据
  init()
  {
    const  ChildFNProductC = this.$refs.childFNProductc;
           ChildFNProductC.HIDDeviceObj = this.HIDDeviceObj;
           ChildFNProductC.KeyMap = this.HIDDeviceObj.MatrixList.KeyMap;
           ChildFNProductC.setProductImagePath();

  },
  initFNData()
  {
      //格式化FN数据
      this.fnData = [];
      for(let i in this.HIDDeviceObj.MatrixList.KeyMap)
      {
        for(let j in this.HIDDeviceObj.MatrixList.KeyMap[i])
        {
          if(this.HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.name != "")
          {

            for(let x in fnData)
            {
              for(let z in fnData[x])
              {
                if(this.HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.fn_code == fnData[x][z].code)
                {
                  this.HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.name = fnData[x][z].name;
                  break;
                }
              }
            }

            // console.log(this.HIDDeviceObj.MatrixList.KeyMap[i][j].key_name + " : " + this.HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.fn_code);

            let obj = 
            {
              "type":this.HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.type,
              "name": "FN+" + this.HIDDeviceObj.MatrixList.KeyMap[i][j].key_name + " : " + this.HIDDeviceObj.MatrixList.KeyMap[i][j].fn_custom.name
            }
            this.fnData.push(obj);
          }
        }
      }
  },
  //读取自定义数据
  async readLayout1Custom()
  {
      this.$notify({duration:0, offset: 120,title: this.$i18n.t("msg.synData"), message: this.$i18n.t("msg.synDataInfo"),type: 'warning'});

      this.HIDDeviceObj.typeMatrixID = cmd10.RESPONSE_CODE.MATRIX6X21_LAYOUT_CODE.FN1;
      let commandFNGroups = this.HIDDeviceObj.getButtonLayout1CustomCommand(cmd10);
      for(let i in commandFNGroups)
      {
          this.HIDDeviceObj.typeMatrixPageID = i+1;
          //写入硬件
          const outputReportData = new Uint8Array(commandFNGroups[i].map(hex => parseInt(hex, 16)));
          this.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

          await ToolsHandle.delay(30);
      }

      await ToolsHandle.delay(1000);
      this.HIDDeviceObj.formatLayout1(cmd10,KeyboardMapConf,fnData,this.HIDDeviceObj);
      this.initFNData();
      this.init();

      this.$notify.closeAll();
  },
  JQSet()
  {
    var context = this;
    //JQ操作
    $(function() 
    { 
        //按键修改
        $(".FNButtonC .keyboard li").click(function()
        {
            var button = $(".FNButtonC .buttons li.on");
            var name = $(this).attr("name");
            var taskname =  $(this).attr("taskname");

            if(taskname == "FN")
            {
              context.$message({message:context.$i18n.t("msg.FNMody"),type: 'warning',center: true,offset:500,duration:1000});
              return false;
            }

            if(button.length == 0)
            {
              context.$message({message:context.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
              return false;
            }
            

            var buttonObj=  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,button.attr("name"));
            var customObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,taskname);

            //恢复高级功能
            cmd10.SET_DEVICE_BUTTON_DEL_CMD[5] = buttonObj.Hid;
            const outputReportData1 = new Uint8Array(cmd10.SET_DEVICE_BUTTON_DEL_CMD.map(hex => parseInt(hex, 16)));
            context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData1);

            //写入硬件
            cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[5] = buttonObj.Hid;
            cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[7] = customObj.Hid;
            cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[8] = "0x00";
            const outputReportData2 = new Uint8Array(cmd10.SET_DEVICE_BUTTON_OP_FN_CMD.map(hex => parseInt(hex, 16)));
            context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData2);

            
            console.log(name);
            //刷新UI
            context.refreshKeyData(button.attr("name"),"KEY",name);
            
        });
        
        //右键修改
        $(".FNButtonC .functions").on("contextmenu","li[data-type='HOTKEY']",function()
        {
            var md5 = $(this).attr("data-md5");
            var name = $(this).attr("data-name");
            var task = $(this).attr("data-task");
            var type = $(this).attr("data-type");

            //功能编辑页面
            if(context.tabName == "HOTKEY")
            {
              context.enterEditPage(type,md5,name,task);
            }
            
        });
        //多功能功能键设置
        $(".FNButtonC .functions").on("click","li",function()
        {
            var md5 = $(this).attr("data-md5");
            var name = $(this).attr("data-name");
            var task = $(this).attr("data-task");
            var type = $(this).attr("data-type");

            var button = $(".FNButtonC .buttons li.on");
            
            if(button.length == 0)
            {
              if(type == "HOTKEY" && context.tabName == "HOTKEY")
              {
                context.$confirm(context.$i18n.t("msg.commandSelectWarn"), context.$i18n.t("msg.confirmTitCommand"), 
                {
                  confirmButtonText:  context.$i18n.t("msg.confirmOKCommand"),
                  cancelButtonText: context.$i18n.t("msg.confirmNoCommand"),
                  type: 'warning'
                }).then(() => 
                {
                  //功能编辑页面
                  context.enterEditPage(type,md5,name,task);

                }).catch(() => {});
              }
              else
              {
                context.$message({message:context.$i18n.t("msg.buttonSelectWarn"),type: 'warning',center: true,offset:500,duration:1000});
              }
              
              return false;
            }

            var buttonObj =  HIDDeviceObj.getBottonHidOJBFromName(KeyboardMapConf,button.attr("name"));
            //恢复高级功能
            cmd10.SET_DEVICE_BUTTON_DEL_CMD[5] = buttonObj.Hid;
            const outputReportData1 = new Uint8Array(cmd10.SET_DEVICE_BUTTON_DEL_CMD.map(hex => parseInt(hex, 16)));
            context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData1);

            switch(type)
            {
              case "mouse":
              {
                  var customObj =  task.split(",");

                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[5] = buttonObj.Hid;
                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[7] = customObj[0];
                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[8] = customObj[1];

                  //写入硬件
                  const outputReportData = new Uint8Array(cmd10.SET_DEVICE_BUTTON_OP_FN_CMD.map(hex => parseInt(hex, 16)));
                  context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

                  //刷新UI
                  context.refreshKeyData(button.attr("name"),"MOUSE",name);

              }break;
              case "HOTKEY":
              {
                  var customObj =  HIDDeviceObj.getHotKeyCommand(KeyboardMapConf,task);

                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[5] = buttonObj.Hid;
                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[7] = customObj.key;
                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[8] = customObj.modifier;

                  //写入硬件
                  const outputReportData = new Uint8Array(cmd10.SET_DEVICE_BUTTON_OP_FN_CMD.map(hex => parseInt(hex, 16)));
                  context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

                  //刷新UI
                  context.refreshKeyData(button.attr("name"),"HOTKEY",name);

              }break;
              case "Media":
              {
                  var customObj =  task.split(",");
                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[5] = buttonObj.Hid;

                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[7] = customObj[0];
                      cmd10.SET_DEVICE_BUTTON_OP_FN_CMD[8] = customObj[1];

                  //写入硬件
                  const outputReportData = new Uint8Array(cmd10.SET_DEVICE_BUTTON_OP_FN_CMD.map(hex => parseInt(hex, 16)));
                  context.HIDDeviceObj.curDeviceHandle.sendReport(0, outputReportData);

                  //刷新UI
                  context.refreshKeyData(button.attr("name"),"MEDIA",name);

              }break;
            }

        });
        //删除命令
        $(".FNButtonC .functions").on("click","li i",function()
        {
            var md5  = $(this).parent().attr("data-md5");
            var index = $(this).parent().attr("data-index");
            var name = $(this).parent().attr("data-name");
            var task = $(this).parent().attr("data-task");
            var type = $(this).parent().attr("data-type");

            context.$confirm(context.$i18n.t("msg.confirmInfoDel"), context.$i18n.t("msg.confirmTitDel"), 
            {
              confirmButtonText:  context.$i18n.t("msg.confirmOKDel"),
              cancelButtonText: context.$i18n.t("msg.confirmNoDel"),
              type: 'warning'
            }).then(() => 
            {
                CommandHandle.delCommad(md5);
                $(this).parent().remove();

                return false;

            }).catch(() => {});

            return false;
        });
    
    });
  },
  //获取图标
  getIconPath(name)
  {
      let imgUrl = require("../../../../asserts/image/command_icon/" + name);   
      
      return '--bgurl: url(' + imgUrl + ')';
  },
  //获取TYPE图标
  getIconTypePath(name,icon)
  {
      let imgUrl = require("../../../../asserts/image/tools/" + name + ".png");   
      
      return '--bgurl: url(' + imgUrl + ')';
  },
  //显示命令名称
  showCommandName(item)
  {
      if(item.type == 'HOTKEY')
      {
        return item.name == ''?item.content:item.name;
      }
      else
      {
        return item.name == ''?item.type:item.name;
      }
  },
  //刷新按键自定义数据
  refreshKeyData(keyName,type,custom)
  {
      let customName = this.HIDDeviceObj.isNumber(parseInt(custom))?"U"+custom:custom;
          custom = keyName == customName?"":custom;
          
      let mapData = this.HIDDeviceObj.MatrixList.KeyMap;
      //组装矩阵数据
      for(let i=0;i<mapData.length;i++)
      {
        for(let j=0;j<mapData[i].length;j++)
        {
            let bottonObj = mapData[i][j];
            let keyNameFromMap = bottonObj.key_name;
            if(keyName == 0)
                continue;

            if(keyName == keyNameFromMap)
            {
                mapData[i][j].fn_custom.type = type;
                mapData[i][j].fn_custom.name = custom;
                mapData[i][j].fn_custom.content = custom;

                console.log(mapData[i][j].fn_custom.name);
            }
        }
      }

      //刷新数据
      const ChildFNProductC = this.$refs.childFNProductc;
            ChildFNProductC.KeyMap = mapData;
      
      this.$message({message:this.$i18n.t("msg.modySuccess"),type: 'success',center: true,offset:500,duration:1000});

  },
  //刷新命令数据
  refreshData(type)
  {
    CommandHandle.initCommand();
    this.myfuns = CommandHandle.getCommandForType(type);
  },
  handleTabClick(tab, event) 
  { 
    this.componentKey += 1;
    let tabName = tab.name;

    switch(tabName)
    {
      case "HOTKEY":
      {
          this.refreshData(tabName);

      }break;
      case "MACRO":
      {
          this.refreshData(tabName);

      }break;

    }
  },
  handleTools(type)
  {
      this.componentKey += 1;
      switch(type)
      { 
        case  "tools":
        {
          this.dialogToolsVisible = true;
        }break;
        case  "macro":
        {
          this.dialogMacroVisible = true;
        }break;
        case  "dks":
        {
          this.dialogDKSVisible = true;
        }break;
        case  "mt":
        {
          this.dialogMTVisible = true;
        }break;
        case  "tgl":
        {
          this.dialogTGLVisible = true;
        }break;
        case  "mpt":
        {
          this.dialogMPTVisible = true;
        }break;
        case  "end":
        {
          this.dialogENDVisible = true;
        }break;
      }
  },
  //保存快捷键
  saveHotKey()
  {
    const context = this;
    const toolsC = this.$refs.childToolsc;
    if(toolsC.auxiliaryKeys.length== 0)
    {      
      this.msg = this.$i18n.t("msg.hotkeySW");
      this.msgShow = true;
      setTimeout(()=>{context.msgShow = false;},2000);
      return;
    }

    if(toolsC.key == "")
    {      
      this.msg = this.$i18n.t("msg.hotkeySW2");
      this.msgShow = true;
      setTimeout(()=>{context.msgShow = false;},2000);
      return;
    }

    let name = toolsC.funcName;

    let commandHotKey = CommandHandle.getHotKey(toolsC.auxiliaryKeys,toolsC.key);
        CommandHandle.hotkeyStructure.content = commandHotKey;


    CommandHandle.hotkeyStructure.name = name;
    CommandHandle.hotkeyStructure.md5 = SparkMD5.hash(Base64.encode(CommandHandle.hotkeyStructure.content));
    if(toolsC.md5 == "")
    {
      CommandHandle.insertCommand(CommandHandle.hotkeyStructure);
    }
    else
    {
      CommandHandle.updateCommad(toolsC.md5,CommandHandle.hotkeyStructure);
    }

    //更新UI位置
    toolsC.auxiliaryKeys = [];
    toolsC.key = "";
    this.dialogToolsVisible = false;

    //刷新数据
    this.tabName = "HOTKEY";
    this.refreshData("HOTKEY");
    this.JQSet();
  },
  //保存宏
  saveMacro(){},
  //功能编辑页面
  enterEditPage(type,md5,name,task)
  {
      var context = this;
      switch(type)
      {
        case "DKS":
        {
          context.dialogDKSVisible = true;
          setTimeout(()=>
          {
            const ChildDKSC = context.$refs.childdksc;
            ChildDKSC.editFunc(md5,name,task); 
          },100);

        }break;
        case "MPT":
        {
          context.dialogMPTVisible = true;
          setTimeout(()=>
          {
            const ChildMPTC = context.$refs.childmptc;
                  ChildMPTC.editFunc(md5,name,task); 
          },100);

        }break;
        case "MT":
        {
          context.dialogMTVisible = true;
          setTimeout(()=>
          {
            const ChildMTC = context.$refs.childmtc;
                  ChildMTC.editFunc(md5,name,task); 
          },100);

        }break;
        case "END":
        {
          context.dialogENDVisible = true;
          setTimeout(()=>
          {
            const ChildENDC = context.$refs.childendc;
                  ChildENDC.editFunc(md5,name,task); 
          },300);

        }break;
        case "TGL":
        {
          context.dialogTGLVisible = true;
          setTimeout(()=>
          {
            const ChildTGLC = context.$refs.childtglc;
                  ChildTGLC.editFunc(md5,name,task); 
          },100);

        }break;
        case "HOTKEY":
        {
          context.dialogToolsVisible = true;
          setTimeout(()=>
          {
            const ChildTOOLSC = context.$refs.childToolsc;
                  ChildTOOLSC.editFunc(md5,name,task); 
          },100);

        }break;
      }
  },

},
computed: 
{
    dynamicCssPath: function() 
    {
      if(this.activeTab == 'button')
      {
        return 'css/buttonTabPane/button.css'; 
      }
      else if(this.activeTab == 'hotkey')
      {
        return 'css/buttonTabPane/hotkey.css';
      }
      else if(this.activeTab == 'app')
      {
        return 'css/buttonTabPane/app.css';
      }
      else if(this.activeTab == 'macro')
      {
        return 'css/buttonTabPane/macro.css';
      }
      else if(this.activeTab == 'advanced')
      {
        return 'css/buttonTabPane/advanced.css';
      }

      return 'css/buttonTabPane/button.css'; 
    }
}
}

</script>